import React from 'react';
import './SearchInvest.scss';
import Select from 'react-select';
import { connect } from 'react-redux';
import {
    changeCenter,
    changeZoom
} from '../../actions/routing';

class SearchInvest extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            przedmiot_inwestycyjny: '',
            przeznaczenie_inwestycji: '',
            forma_wladania: '',
            dostepnosc_infrastruktury_technicznej: '',
            powierzchnia_od: '',
            powierzchnia_do: '',
            oferty: [],
            pokaz_oferty: false,
            showModal: false,
            selected_oferta: '',
            show_oferta: false,
            pokaz_wyszukiwarke: true
        }
    }

    handleChangeSelect = (e, name) => {
        this.setState({
            [name]: e.value
        });
    }

    handleChange = (e, name) => {
        this.setState({
            [name]: e.target.value
        });
    }

    setDataToModal = (v) => {
        this.setState({
            selected_oferta: v,
            show_oferta: true
        });
    }

    showForm = () => {
        this.setState({
            pokaz_wyszukiwarke: true
        });
    }
    // To przybliża do konkretnych działek
    /**
     * param x: geojson
     */
    moveToPolygon = (x) => {
        const bounds = window.L.geoJSON(x).getBounds();
        this.props.changeCenter(bounds.getCenter());
        this.props.changeZoom(18);
    }

    search = () => {
        // let url = `http://localhost:8000/api/v1.0/invest/${this.props.prefix}/search`;
        let url = `${process.env.API_URL}/invest/${this.props.prefix}/search`;

        let data = {
            "powierzchniaod": this.state.powierzchnia_od,
            "powierzchniado": this.state.powierzchnia_do,
            "przedmiot": this.state.przedmiot_inwestycyjny,
            "przeznaczenie": this.state.przeznaczenie_inwestycji,
            "forma": this.state.forma_wladania,
            "dostepnosc": this.state.dostepnosc_infrastruktury_technicznej
        }

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json, */*',
            },
            body: JSON.stringify(data)
        })
        .then(r => r.json())
        .then(resp => {
          resp.oferty.map(v => {
            v.geom = JSON.parse(v.geom)
          });
          this.setState({
            oferty: resp.oferty,
            pokaz_oferty: true,
            pokaz_wyszukiwarke: false,
          });
        });
    }

    render() {
        // Opcje wybory dla Przedmiotu inwestycyjnego
        const options_przedmiot_inwestycjny = [
            { value: "", label: "---" },
            { value: "tereny inwestycyjne przemysłowo - usługowe", label: "Tereny inwestycyjne przemysłowo - usługowe" },
            { value: "hale produkcyjno - magazynoweo - usługowe", label: "Hale produkcyjno - magazynoweo - usługowe" },
            { value: "powierzchnie biurowe", label: "Powierzchnie biurowe" },
            { value: "oferty dla branży turystycznej,", label: "Oferty dla branży turystycznej" },
            { value: "inne", label: "Inne" },
        ]

        const options_przedmiot_inwestycjny_en = [
            {value: "", label: "---"},
            {value: "industrial and service investment areas", label: "Industrial and service investment areas"},
            {value: "production and warehouse halls - service halls", label: "Production and warehouse halls - service halls"},
            {value: "office space", label: "Office space"},
            {value: "offers for the tourism industry,", label: "Offers for the tourism industry"},
            {value: "other", label: "Other"}
        ];

        const options_przedmiot_inwestycjny_de = [
            {value: "", label: "---"},
            {value: "Industrie - und Dienstleistungsinvestitionsbereiche", label: "Industrie - und Dienstleistungsinvestitionsbereiche"},
            {value: "Produktions - und Lagerhallen - Servicehallen", label: "Produktions - und Lagerhallen - Servicehallen"},
            {value: "Bürofläche", label: "Bürofläche"},
            {value: "Angebote für die Tourismusbranche", label: "Angebote für die Tourismusbranche"},
            {value: "other", label: "other"}
        ];

        // Opcje dla przeznaczenia inwestycyjnego
        const options_przeznaczenie = [
            { value: "", label: "---" },
            {value: "przemysł", label: "Przemysł"},
            {value: "logistyka i transport", label: "Logistyka i transport"},
            {value: "budownictwo mieszkaniowe", label: "Budownictwo mieszkaniowe"},
            {value: "centra sportowe i rekreacyjne", label: "Centra sportowe i rekreacyjne"},
            {value: "turystyka", label: "Turystyka"},
            {value: "gastronomia", label: "Gastronomia"},
            {value: "rolnictwo", label: "Rolnictwo"},
            {value: "centra handlowe", label: "Centra handlowe"},
            {value: "centra biurowe", label: "Centra biurowe"},
            {value: "farmy wiatrowe", label: "Farmy wiatrowe"},
            {value: "farmy słoneczne i biogazownie", label: "Farmy słoneczne i biogazownie"},
            {value: "partnerstwo publiczno-prywatne", label: "Partnerstwo publiczno-prywatne"},
            {value: "magazyny i składy", label: "Magazyny i składy"},
            {value: "usługi", label: "Usługi"},
            {value: "aktywizacja gospodarcza", label: "Aktywizacja gospodarcza"},
            {value: "przemysł nieuciążliwy", label: "Przemysł nieuciążliwy"},
            {value: "działalność lotnicza", label: "Działalność lotnicza"},
            {value: "rzemiosło produkcyjne", label: "Rzemiosło produkcyjne"}
        ]

        const options_przeznaczenie_de = [
            {value: "", label: "---"},
            {value: "Industrie", label: "Industrie"},
            {value: "Logistik und Transport", label: "Logistik und Transport"},
            {value: "Wohnungsbau", label: "Wohnungsbau"},
            {value: "Sport- und Freizeitzentren", label: "Sport- und Freizeitzentren"},
            {value: "Tourismus", label: "Tourismus"},
            {value: "Gastronomie", label: "Gastronomie"},
            {value: "Landwirtschaft", label: "Landwirtschaft"},
            {value: "Einkaufszentren", label: "Einkaufszentren"},
            {value: "Bürozentren", label: "Bürozentren"},
            {value: "Windparks", label: "Windparks"},
            {value: "Solarparks und Biogasanlagen", label: "Solarparks und Biogasanlagen"},
            {value: "Public-Private-Partnership", label: "Public-Private-Partnership"},
            {value: "lager und lager", aufschrift: "lager und lager"},
            {value: "services", label: "Services"},
            {value: "wirtschaftliche Aktivierung", label: "wirtschaftliche Aktivierung"},
            {value: "unauffällige Industrie", label: "unauffällige Industrie"},
            {value: "Luftfahrtaktivität", label: "Luftfahrtaktivitäten"},
            {value: "Handwerkskunst", label: "Handwerkskunst"}
        ]

        const options_przeznaczenie_en = [
            {value: "", label: "---"},
            {value: "industry", label: "Industry"},
            {value: "logistics and transport", label: "Logistics and transport"},
            {value: "housing construction", label: "Housing construction"},
            {value: "sports and recreation centers", label: "Sports and recreation centers"},
            {value: "tourism", label: "Tourism"},
            {value: "gastronomy", label: "Gastronomy"},
            {value: "agriculture", label: "Agriculture"},
            {value: "shopping centers", label: "Shopping centers"},
            {value: "office centers", label: "Office centers"},
            {value: "windfarms", label: "Wind farms"},
            {value: "solar farms and biogas plants", label: "Solar farms and biogas plants"},
            {value: "public-private partnership", label: "Public-private partnership"},
            {value: "warehouses and warehouses", label: "Warehouses and warehouses"},
            {value: "services", label: "Services"},
            {value: "economic activation", label: "Economic activation"},
            {value: "unobtrusive industry", label: "Unobtrusive industry"},
            {value: "aviation activity", label: "Aviation activities"},
            {value: "production craftsmanship", label: "Production craftsmanship"}
        ]

        // Opcje dla formy władania
        const options_forma_wladania = [
            { value: "", label: "---" },
            {value: "sprzedaż", label: "Sprzedaż"},
            {value: "użytkowanie wieczyste", label: "Użytkowanie wieczyste"},
            {value: "dzierżawa", label: "Dzierżawa"},
            {value: "najem", label: "Najem"}
        ]

        const options_forma_wladania_en = [
            {value: "", label: "---"},
            {value: "sale", label: "Sales"},
            {value: "perpetual usufruct", label: "Perpetual usufruct"},
            {value: "lease", label: "Lease"},
            {value: "rent", label: "Rent"}
        ]

        const options_forma_wladania_de = [
            {value: "", label: "---"},
            {value: "sale", label: "Sales"},
            {value: "ewiger Nießbrauch", label: "ewiger Nießbrauch"},
            {value: "lease", label: "lease"},
            {value: "rent", label: "Rent"}
        ]
        // Opcje dla dostepnosci
        const options_dostepnosc = [
            { value: "", label: "---" },
            {label: "Sieć elektroenergetyczna", value: "Sieć elek%"},
            {label: "Sieć wodociągowa", value: "Sieć wod%"},
            {label: "Sieć kanalizacyjna", value: "Sieć kana%"},
            {label: "Sieć telekomunikacyjna", value: "Sieć tel%"}
        ];

        const options_dostepnosc_de = [
            {value: "", label: "---"},
            {label: "Power Grid", value: "Sieć elek%"},
            {label: "Leitungswasser", value: "Sieć wod%"},
            {label: "Kanalnetz", value: "Sieć kana%"},
            {label: "Telekommunikationsnetz", value: "Sieć tel%"}
        ];

        const options_dostepnosc_en = [
            {value: "", label: "---"},
            {label: "Power Grid", value: "Sieć elek%"},
            {label: "Water supply network", value: "Sieć wod%"},
            {label: "Sewer network", value: "Sieć kana%"},
            {label: "Telecommunications network", value: "Sieć tel%"}
        ];

        let option_przedmiot = null,
            option_przeznaczenie = null,
            option_wladanie = null,
            option_dostepnosc = null;

        if(this.props.intl.locale == 'pl-PL') {
            option_przedmiot = options_przedmiot_inwestycjny;
            option_przeznaczenie = options_przeznaczenie;
            option_wladanie = options_forma_wladania;
            option_dostepnosc = options_dostepnosc;
        } else if(this.props.intl.locale == 'en-EN') {
            option_przedmiot = options_przedmiot_inwestycjny_en;
            option_przeznaczenie = options_przeznaczenie_en;
            option_wladanie = options_forma_wladania_en;
            option_dostepnosc = options_dostepnosc_en;
        } else {
            option_przedmiot = options_przedmiot_inwestycjny_de;
            option_przeznaczenie = options_przeznaczenie_de;
            option_wladanie = options_forma_wladania_de;
            option_dostepnosc = options_dostepnosc_de;
        }

        const style = {
            width: '70%'
        };

        const styleCursor = {
            cursor: 'pointer'
        }

        return(
            <div className="col-xs-12">
                {this.state.pokaz_wyszukiwarke ?
                    <div>
                        <div className="row">
                        <div className="form-group">
                            <label htmlFor="przeznaczenieInwestycji">{this.props.intl.langKeys.przedInvest}</label>
                            <Select
                                clearable={false}
                                options={option_przedmiot}
                                value={this.state.przedmiot_inwestycyjny}
                                placeholder="Wybierz przedmiot inwestycjny..."
                                onChange={(e) => this.handleChangeSelect(e, 'przedmiot_inwestycyjny')}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group">
                            <label htmlFor="przeznaczenieInwestycji">{this.props.intl.langKeys.przeznaczenieInvest}</label>
                            <Select
                                clearable={false}
                                options={option_przeznaczenie}
                                value={this.state.przeznaczenie_inwestycji}
                                placeholder="Wybierz przeznaczenie inwestycji..."
                                onChange={(e) => this.handleChangeSelect(e, 'przeznaczenie_inwestycji')}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group">
                            <label htmlFor="formaWladania">{this.props.intl.langKeys.formaWladowania}</label>
                            <Select
                                clearable={false}
                                options={option_wladanie}
                                value={this.state.forma_wladania}
                                placeholder="Wybierz formę władania..."
                                onChange={(e) => this.handleChangeSelect(e, 'forma_wladania')}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group">
                            <label htmlFor="formaWladania">{this.props.intl.langKeys.dostInfraTech}</label>
                            <Select
                                clearable={false}
                                options={option_dostepnosc}
                                value={this.state.dostepnosc_infrastruktury_technicznej}
                                placeholder="Wybierz dostępność infrastruktury technincznej..."
                                onChange={(e) => this.handleChangeSelect(e, 'dostepnosc_infrastruktury_technicznej')}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group">
                            <label htmlFor="formaWladania">{this.props.intl.langKeys.powNieruchoOd} [m<sup>2</sup>]</label>
                            <input type="number" className="form-control" value={this.state.powierzchnia_od} onChange={(e) => this.handleChange(e, 'powierzchnia_od')} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group">
                            <label htmlFor="formaWladania">{this.props.intl.langKeys.powNieruchoDo} [m<sup>2</sup>]</label>
                            <input type="number" className="form-control" value={this.state.powierzchnia_do} onChange={(e) => this.handleChange(e, 'powierzchnia_do')} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group">
                            <button className="btn btn-primary" onClick={() => this.search()}>{this.props.intl.langKeys.szukaj}</button>
                        </div>
                    </div>
                    </div>
                    : null}
                {this.state.pokaz_oferty ?
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-4">
                            <h3>Oferty</h3>
                        </div>

                        <div className="col-xs-8">
                            {!this.state.pokaz_wyszukiwarke ? <button onClick={() => this.showForm()} className="btn btn-primary">Pokaż wyszukiwarkę</button> : null}
                        </div>
                    </div>
                    <br />
                    <table className="table">
                    <tbody>
                        {this.state.oferty.length == 0 ? <div>Brak ofert o podanych parametrach!</div> :
                        this.state.oferty.map((v, i) => {
                            return (
                                <tr key={i}>
                                    <td style={style}>{v.nazwa}</td>
                                    <td><i style={styleCursor} className="glyphicon glyphicon-zoom-in" onClick={() => this.moveToPolygon(v.geom)}></i></td>
                                    <td><i style={styleCursor} className="glyphicon glyphicon-info-sign" onClick={() => this.setDataToModal(v)}></i></td>
                                </tr>
                            )
                        })}

                    </tbody>
                    </table>
                </div> : null}

                {this.state.show_oferta ?
                    <div>
                        <b>Nazwa oferty:</b> {this.state.selected_oferta.nazwa}<br />
                        <b>Infrastruktura:</b> {this.state.selected_oferta.infrastruktura}<br />
                        <b>Atrybuty:</b> {this.state.selected_oferta.atrybuty}<br />
                        <b>Opis:</b> {this.state.selected_oferta.opis}<br />
                        <b>Strona WWW:</b> <a href="{this.state.selected_oferta.www}">Przejdź do strony</a>
                        <br />
                        <br />
                        <b>Kontakt</b><br />
                        {this.state.selected_oferta.kontakt_nazwa}<br />
                        {this.state.selected_oferta.kontakt_imie} {this.state.selected_oferta.kontakt_nazwisko}<br />
                        {this.state.selected_oferta.kontakt_telefon}<br />
                        ul. {this.state.selected_oferta.kontakt_ulica} {this.state.selected_oferta.kontakt_nrBud}{this.state.selected_oferta.nrLok != undefined ? <span>/{this.state.selected_oferta.kontakt_nrLok}</span> : null}, {this.state.selected_oferta.kontakt_kod} {this.state.selected_oferta.kontakt_miejscowosc})
                    </div>
                : null}
            </div>
        )
    }
}

const mapState = (state) => ({
  intl: state.intl,
});

const mapDispatch = {
  changeCenter,
  changeZoom,
}

export default connect(mapState, mapDispatch)(SearchInvest);



// WEBPACK FOOTER //
// src/components/SearchInvest/SearchInvest.js